'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/* injects from baggage-loader */

exports.default = {
  NODE: 'node',
  SCENE: 'scene',
  NODE_HANDLE: 'node_handle'
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectView/projectDragItemTypes.js
// module id = 138
// module chunks = 1